import { Loading } from 'module/ui/components/atoms/loading';
import { OutsideClickHandler } from 'module/ui/components/atoms/outside-click-handler';
import { useParams } from '@rocketlane/rocket-router';
import { Select } from '@rocketlane/ui';
import { useSalesForceTriggerObjectsQuery } from 'queries/salesforce';
import { FC, useCallback, useState } from 'react';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { BlockList } from 'components/organisms/signal/detail/block-list/list';
import { StopClickEventPropagation } from 'components/organisms/signal/detail/stop-click-event-propagration';
import { useAutomationContext } from './automation-context';
import type { SalesforceObjectOption } from 'module/api/integrations/salesforce/types';

export const AutomationObjectPickerBlock: FC = () => {
  const { automationDetails, setAutomationDetails } = useAutomationContext();

  const { salesforceObject: selectedSalesforceObject } =
    automationDetails || {};

  const [isObjectPickerCollapsed, setIsObjectPickerCollapsed] = useState(true);

  const { integrationId } = useParams<{ integrationId: string }>();

  const { data: salesforceObjects, isLoading } =
    useSalesForceTriggerObjectsQuery(parseInt(integrationId || '0'), {});

  const transformedOptions = useMemo(
    () =>
      salesforceObjects?.map((salseforceObject) => ({
        label: salseforceObject.name,
        value: salseforceObject.id,
      })),
    [salesforceObjects],
  );

  const onOutsideClick = useCallback(() => {
    setIsObjectPickerCollapsed(true);
  }, []);

  return (
    <OutsideClickHandler onOutsideClick={onOutsideClick}>
      <BlockList.CollapsibleItem
        collasped={isObjectPickerCollapsed}
        onCollapseChange={(collapsed) => {
          setIsObjectPickerCollapsed(collapsed);

          return true;
        }}
      >
        <BlockList.CollapsibleItem.Label data-required="true">
          <BlockList.CollapsibleItem.Label.Text>
            <FormattedMessage id="settings.integrations.create.automation.object.label" />
          </BlockList.CollapsibleItem.Label.Text>
        </BlockList.CollapsibleItem.Label>
        <BlockList.CollapsibleItem.Content>
          {isLoading || !selectedSalesforceObject ? (
            <div className="flex gap-2">
              <span className="body-short-sb text-[var(--text-placeholder)]">
                Eg: Opportunity
              </span>

              {isLoading && <Loading />}
            </div>
          ) : (
            <div className="short-01">{selectedSalesforceObject?.label}</div>
          )}
        </BlockList.CollapsibleItem.Content>
        <BlockList.CollapsibleItem.ExpandedContent>
          <StopClickEventPropagation>
            <Select<SalesforceObjectOption>
              options={transformedOptions}
              value={selectedSalesforceObject}
              onChange={(selectedOption) => {
                if (selectedOption) {
                  setAutomationDetails({
                    salesforceObject: selectedOption,
                  });
                }
              }}
              isLoading={isLoading}
              menuPortalTarget={document.body}
            />
          </StopClickEventPropagation>
        </BlockList.CollapsibleItem.ExpandedContent>
      </BlockList.CollapsibleItem>
    </OutsideClickHandler>
  );
};
